import { cn } from "@/lib/cn";
import type { BrandMarkProps } from "../types";
import coinUrl from "./richpoll/richpoll-coin.png";
import wordmarkUrl from "./richpoll/richpoll-wordmark.png";

// RichPoll's marks. The supplied artwork is raster (Richpoll-Logo-01.png, the
// horizontal lockup, and Richpoll-Logo-02.png, the coin), so these render an
// <img> where SmartMarket renders an inline SVG. Both honour the same
// className/style sizing contract, and `object-contain` keeps the aspect ratio
// whichever side the caller pins — `h-7 w-auto`, `h-auto w-[175px]` and
// `style={{ width: "0.92em", height: "0.92em" }}` all behave.
//
// A raster mark carries its own colours, so the `text-*` tints call sites put
// on the glyph simply have no effect here. That is the intended trade: the
// coin is gold by design, not by token.

function RasterMark({
  src,
  className,
  style,
  "aria-label": ariaLabel,
  "aria-hidden": ariaHidden,
}: BrandMarkProps & { src: string }) {
  return (
    <img
      src={src}
      // A labelled mark keeps its label as alt text; an unlabelled one is
      // decorative and stays out of the accessibility tree, exactly as the
      // aria-hidden SVGs it replaces did.
      alt={ariaLabel ?? ""}
      aria-hidden={ariaHidden}
      className={cn("object-contain", className)}
      style={style}
      draggable={false}
    />
  );
}

/** Horizontal RICH POLL lockup (wordmark + coin). */
export function RichPollWordmark(props: BrandMarkProps) {
  return <RasterMark src={wordmarkUrl} {...props} />;
}

/**
 * Compact lockup. RichPoll ships a single lockup, whose wordmark is already
 * stacked on two lines, so the tablet-portrait slot uses it too rather than
 * inventing artwork the brand has not approved.
 */
export function RichPollStacked(props: BrandMarkProps) {
  return <RasterMark src={wordmarkUrl} {...props} />;
}

/** The coin — RichPoll's icon-only mark. */
export function RichPollCoin(props: BrandMarkProps) {
  return <RasterMark src={coinUrl} {...props} />;
}
